/**
 * Vypnutí tažení MYŠÍ u produktových carouselů (opt-in přes `data-no-mouse-drag` na kontejneru).
 *
 * Záměr: na desktopu se carousel ovládá ŠIPKAMI, ne tahem myši (vestavěný drag Horizon
 * `slideshow-component` „stránkuje" a působí nešikovně). Tah PRSTEM na mobilu/tabletu zůstává —
 * nativní touch scroll nejde přes `mousedown`, takže ho tohle neovlivní. Šipky, kolečko i
 * kliknutí na produkt fungují dál.
 *
 * Jak: built-in drag je `mousedown` listener na scrolleru (`[ref="scroller"]`). Capture-phase
 * `mousedown` na `slideshow-component` (PŘEDEK scrolleru) běží dřív; `stopPropagation()` ho ke
 * scrolleru nepustí → vestavěný drag se nespustí. NepreventDefaultujeme → klik/odkazy jedou dál.
 *
 * Sdílený asset, vanilla, MIMO importmapu (`<script defer>` ve scripts.liquid).
 */
(() => {
  const SELECTOR = '[data-no-mouse-drag] .resource-list__carousel slideshow-component';

  const block = (comp) => {
    const scroller = comp.querySelector('[ref="scroller"]');
    if (!scroller || scroller.dataset.noMouseDrag) return;
    scroller.dataset.noMouseDrag = '1';
    scroller.style.cursor = 'default'; // bez „grab" — tah myší stejně nejde

    comp.addEventListener(
      'mousedown',
      (event) => {
        if (event.button !== 0) return;
        if (!(event.target instanceof Element)) return;
        if (!scroller.contains(event.target)) return; // šipky/ovládání nech být
        // Zastav, ať se built-in mousedown drag (registrovaný na scrolleru) nespustí.
        // Klik (a tím navigace na produkt) jede dál — neprevent­Defaultujeme.
        event.stopPropagation();
      },
      true
    );
  };

  const scan = (root) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(block);
    // Když je `root` sám slideshow-component v opt-in kontejneru (lazy inject recommendations).
    if (
      root instanceof Element &&
      root.matches('slideshow-component') &&
      root.closest('[data-no-mouse-drag] .resource-list__carousel')
    ) {
      block(root);
    }
  };

  const init = () => {
    scan(document);

    // Lazy injektnuté carousely (product-recommendations fetch) + theme editor re-render.
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
